import { th, thd, styled } from '@smooth-ui/core-sc';
import { transparentize } from 'polished';

const FormStyles = styled.div`
  a {
    font-weight: normal;
  }

  label {
    color: #192849 !important;
    font-weight: bold;
    font-size: 14px;

    a {
      font-weight: bold;
    }
    span {
      font-weight: normal;
    }
  }

  .sui-input,
  .react-select > div,
  textarea {
    background-color: #f5f5f5;
    border: none;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }

  .react-select .rs__input {
    background-color: transparent !important;
  }

  .sui-input {
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
  }

  @media (min-width: 576px) {
    .invoice-product-remove button {
      margin-top: 2.4em !important;
    }
  }

  .rs__single-value {
    background-color: transparent !important;
  }

  .sui-checkbox-content {
    width: 28px !important;
    height: 24px !important;
    background-color: #fafafa;
    border-radius: 5px !important;
  }

  .sui-checkbox-content,
  input:checked + .sui-checkbox-content {
    background-color: #fafafa !important;
    border: 1px solid #e5e5e5 !important;
  }

  .sui-checkbox-check {
    color: ${thd('primary', '#1C355E')} !important;
    width: 12px !important;
    height: 12px !important;
  }

  .sui-form-check-label,
  a {
    color: black;
  }

  .sui-form-check-label {
    font-weight: normal;
  }

  .cart-cta a,
  .sui-button {
    font-size: 14px;
    font-weight: bold;
    padding: 10px 12px;
    background-color: ${thd('primary', 'black')};
    color: white;
    &:not(:disabled):hover,
    :not(:disabled):focus {
      background-color: ${th('text')};
    }
  }

  .sui-alert {
    border-radius: 5px;
    border-color: #d92e1f;
    color: black;
    background-color: #ffdabc;
  }

  .lori-input-hint {
    color: black;
  }

  .dropzone .lori-input-hint + div {
    margin: 0;
    overflow: hidden;
    border-radius: 5px;
    border: 1px solid #e5e5e5;
    color: #9d9d9d;
  }

  .sui-button:disabled {
    opacity: 0.24;
  }

  .invoice-product-remove {
    margin-bottom: 1rem;
  }

  .DayPicker-Day {
    padding: 0.2em 0.5em;
    color: #8b9898;
  }

  .DayPicker-Day--today {
    color: ${th('primary')};
  }

  .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover,
  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
    background: ${transparentize(0.75, '#0096D6')};
    color: black;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    background: ${th('secondary')};
  }

  .filesContainer {
    .lori-input-hint + div {
      margin: 0 !important;
    }
  }

  &.text--white {
    .lori-input-hint,
    label {
      color: white !important;
    }
  }
`;

export default FormStyles;
